import { DataBean } from "../DataBean";

export class SalesOrderEvent extends DataBean {

    public async getSalesOrderOperations(args: number | null): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesOrderOperations_Number", [args]);
    }

    public async deleteSalesOrderEvent(idSalesOrderEvent: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSalesOrderEvent_Number", [idSalesOrderEvent]);
    }

    public async getSalesOrderEventCatalog(year: number, idSalesOrder: number, state: number, regexStr: string, page: number, recordsPerPage: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getSalesOrderEventCatalog_Number_Number_Number_String_Number_Number", [year, idSalesOrder, state, regexStr, page, recordsPerPage]);
    }

    public async getSalesOrderEventCatalogBySalesOrder(idSalesOrder: number, salesOrderDate: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSalesOrderEventCatalog_Number_java.util.Date", [idSalesOrder, salesOrderDate]);
    }

    public async addSalesOrderEvent(idSalesOrder: number, salesOrderDate: any, state: number, observations: string, idEmployee: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderEvent_addSalesOrderEvent_Number_java.util.Date_Number_String_Number", [idSalesOrder, salesOrderDate, state, observations, idEmployee]);
    }

    public async updateSalesOrderEvent(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.sales.SalesOrderEvent_updateSalesOrderEvent_com.quickdataerp.bean.sales.SalesOrderEvent", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.sales.SalesOrderEvent"
            }
        ]);
    }

}
